import React, { useState } from "react";
import { MediumType } from "./MediumType";
import AButton from "../../../../common/form-fields-mui/AButton";
import useInitiatePayment from "../pos/pinelap/UI/apicall";
import CountdownLoader from "./TimerWithLoader";
import { useFetchContactDetails } from "../../context/customHook";
import ALoader from "views/pages/manage/common/a-loader";
import LinkTxnCanceled from "./CancelTxnPlaceholder";
import FailedStateCard from "../pos/TxnFailedState";
import {getDescription} from './constant'



const PaymentLink = ({
  contextValue,
  isReceiptEdit = false,
  isView = false,
  rowId,
  handleClose = () => {},
}) => {
  const {
    setBalanceMode,
    setBalanceAmount,
    setCollectPayment,
    currentPaymentMode,
    bankMasterId,
    balanceAmount,
    studentBasicDetails,
    selectedCharges,
  } = contextValue;

  // const { REGULAR_CHARGES, OTHER_CHARGES } = selectedCharges;

  const itemsSelectedForPayment =
  selectedCharges?.REGULAR_CHARGES.length > 0 ? selectedCharges?.REGULAR_CHARGES : selectedCharges?.OTHER_CHARGES;

  const studentContactDetails = useFetchContactDetails(
    studentBasicDetails?.applicationId,
    studentBasicDetails?.opportunityOwnerId

  );

  const [currentMedium, setCurrentMedium] = useState([]);
  const [errorMsg, setErrorMsg] = useState(false);
  const [cancelTxnLoader, setCancelTxnLoader] = useState(false);

  const {
    initiatePayment,
    responseData,
    loader,
    setResponse,
    cancelLinkTransaction,
  } = useInitiatePayment(
    setBalanceAmount,
    setBalanceMode,
    setCollectPayment,
    currentPaymentMode,
    bankMasterId
  );

  const sendPaymentLink = () => {
    const channelType = currentMedium.map((m) => m.type);
    if (channelType.length === 0) return;
    const request = {
      channelType,
    };

    if (channelType.includes("EMAIL"))
      request["email"] = studentContactDetails.contactDetails?.email;
    if (channelType.includes("SMS") || channelType.includes("WHATSAPP"))
      request["contactNumber"] = studentContactDetails.contactDetails?.mobile;

    request["description"] = getDescription(itemsSelectedForPayment)

    initiatePayment(contextValue?.studentBasicDetails, balanceAmount, {
      value: "link",
      notification: request,
    },contextValue?.state,contextValue?.setState);
    setErrorMsg("");
  };

  const cancelTxnHandler = () => {
    if (responseData?.businessAreaId && responseData?.clientTransactionId)
      cancelLinkTransaction(responseData, setCancelTxnLoader);
  };
  if (responseData && responseData?.data?.status === "CANCELLED")
    return <LinkTxnCanceled />;

  if (responseData && responseData?.data?.status === "FAILED")
    return (
      <FailedStateCard
        paymentMode="Via Link"
        retryHandler={() => setResponse({})}
      />
    );

  return (
    <>
      {!isView && !isReceiptEdit && (
        <div className=" d-flex justify-content-between align-items-center mt-2">
          <span className="large-bold color-dark">Payment link</span>
        </div>
      )}
      {loader && (
        <CountdownLoader
          cancelTransaction={cancelTxnHandler}
          isLoaderActive={loader}
          isShowCancelButton={responseData?.clientTransactionId}
        />
      )}
      {cancelTxnLoader && <ALoader />}

      {!loader && (
        <>
          <span className="semi-bold">Send link via</span>
          <MediumType
            currentMedium={currentMedium}
            studentContactDetails={studentContactDetails}
            setCurrentMedium={setCurrentMedium}
            studentName = {studentBasicDetails?.studentName}
          />
          <AButton
            className="button_remove_left_margin mt-4"
            variant="primary_filled"
            onClick={sendPaymentLink}
            disabled={balanceAmount<=0 || currentMedium.length === 0}
          >
            Send Payment link
          </AButton>
        </>
      )}
    </>
  );
};
export default PaymentLink;
